import styled from "@emotion/styled";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;

  @media (max-width: 600px) {
    margin-bottom: 5px;
  }
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
  margin: 0px 0px 15px 0px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Children = styled.div`
  flex: 2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

const Container = styled.div``;

const CommentSection = styled.p`
  font-weight: bold;
  font-size: 12px;
`;

const DropzoneWrapper = styled.div`
  border: 2px dashed ${theme.colors.borderColor};
  border-color: ${theme.colors.lightBlue};
  border-radius: 7px;
  text-align: center;
  padding: 15px;
  box-sizing: border-box;
  outline: none;
  tabindex: 0;
  cursor: pointer;
  width: -webkit-fill-available;
`;

const UploadFileContiner = styled.div`
  justify-content: center;
`;

const StyledSpan = styled.span`
  color: ${theme.colors.blue};
  cursor: pointer;
  margin-left: 5px;
`;

const CloseIcon = styled(InnoIcons.CancelIcon)`
  font-size: 20px;
  color: ${theme.colors.red};
  cursor: pointer;
`;

const Image = styled.img`
  margin-right: 8px;
  width: 20px;
  height: 15px;
`;
const InputFile = styled.input``;

const ButtonContainer = styled.div`
  margin-top: 15px;
`;

const Span = styled.span``;

const UploadIcon = styled(InnoIcons.CloudUploadOutlinedIcon)`
  font-size: 24px;
  color: ${theme.colors.blue};
  margin-right: 8px;
`;

const DropzoneText = styled.span`
  font-size: 1rem;
  color: ${theme.colors.dropzonetext};
  height: 120px;
`;

const PreviewsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

const PreviewBox = styled.div`
  display: flex;
  position: relative;
  border: 1px solid ${theme.colors.borderColor};
  border-radius: 7px;
  padding: 15px;
  // max-width: 510px;
  width: 100%;
  height: 55px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const RemoveButton = styled.button`
  position: relative;
  margin-top: 5px;
  right: 0;
  background: ${theme.colors.buttonBackground};
  border: none;
  color: ${theme.colors.buttonText};
  padding: 5px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 3px;
  transition: background 0.3s ease;
`;

const FileName = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: black;
  max-width: 150px;
  width: 100%;
  white-space: wrap;
  margin: 0px 5px;

  @media (max-width: 600px) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const FileSize = styled.p`
  padding-block: 0px;
  margin-block: 0px;
  font-weight: normal;
`;

const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SC = {
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  Container,
  CommentSection,
  DropzoneWrapper,
  UploadFileContiner,
  StyledSpan,
  CloseIcon,
  Image,
  InputFile,
  ButtonContainer,
  Span,
  UploadIcon,
  DropzoneText,
  PreviewsContainer,
  PreviewBox,
  RemoveButton,
  FileName,
  FileSize,
  PreviewContainer,
};

export default SC;
